import { ExperimentsSelectors } from '@web_opxp/features';
import { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { IState } from '../../store/state';

export default function MoodTrackerWrapper({ children }: PropsWithChildren) {
  const experimentEnabled = useSelector<IState>((s) => ExperimentsSelectors.isExperimentEnabled(s, 7428));
  if (!experimentEnabled) {
    return null;
  }
  return children;
}
